import styled, { css } from 'styled-components';

import colors from 'apps/promo/theme/colors';
import media from 'apps/promo/theme/media';

const getPanelRowJustify = (props) => {
    if (props.alignStart) {
        return 'start';
    }
    return props.alignEnd ? 'end' : 'space-between';
};

const CommonCss = css`
    display: flex;
    justify-content: start;
    align-items: center;
    cursor: pointer;
    padding: ${(props) => (props.$isBordered ? '24px' : '16px 24px')};
    border: ${(props) => (props.$isBordered ? `1px solid ${colors.greyRgba28}` : 'none')};
    border-radius: ${(props) => (props.$hasBorderRadius ? '12px' : '0')};
    width: ${(props) => (props.$negativeMargin ? 'calc(100% + 48px)' : '100%')};
    margin: ${(props) => (props.$negativeMargin ? '0 -24px' : null)};
    background: none;
    color: inherit;
    box-sizing: border-box;
    position: relative;
    /* to reset css on button */
    font-family: inherit;
    line-height: inherit;
    font-size: inherit;
    text-align: left;

    ${media.desktop1920} {
        padding: 20px 32px;
        border-radius: ${(props) => (props.$hasBorderRadius ? '16px' : null)};
    }

    &:hover,
    &:active {
        background: ${(props) => (props.$isHoverable ? colors.superLightGray : 'none')};
    }
`;

export const PanelContainerBlock = styled.div`
    ${CommonCss}
`;
export const PanelContainerLink = styled.a`
    ${CommonCss}
`;

/* inside panel */
export const PanelRow = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    overflow: hidden;
    justify-content: ${(props) => getPanelRowJustify(props)};
`;
export const PanelFrame = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    ${PanelRow} {
        margin-bottom: 4px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;
export const DiskBadgeWrapper = styled.span`
    display: inline-flex;
    margin-right: 16px;
    position: relative;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

export const LightSelectedDiskBadge = styled.span`
    position: absolute;
    left: 0;
    top: 0;
`;

export const PanelRightBlock = styled.div`
    margin-left: 16px;
    text-align: right;
    white-space: nowrap;
    display: ${(props) => (props.flex ? 'flex' : null)};
    align-items: ${(props) => (props.flex ? 'center' : null)};

    ${media.desktop1920} {
        margin-left: 24px;
    }
`;
